import { useState, useEffect, useCallback } from 'react';
import { fetchBusinesses } from '../api/businessesApi';
import type { Business } from '../types';

interface UseBusinessesReturn {
  businesses: Business[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Hook to fetch all businesses (for super admin business selector)
 */
export function useBusinesses(): UseBusinessesReturn {
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadBusinesses = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await fetchBusinesses();
      setBusinesses(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load businesses';
      setError(message);
      console.error('[useBusinesses] Error:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadBusinesses();
  }, [loadBusinesses]);

  return {
    businesses,
    isLoading,
    error,
    refetch: loadBusinesses,
  };
}